export default {
      id: "burger-usage",
      viewBox: "0 0 44 32",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#burger",
      toString: function () {
        return this.url;
      }
    }